{
  const BaseModule = require('_base/base')

  const CLASS_WIDE_IMAGE = 'is__panoramicWide'
  const MOBILE_SCROLL_FACTOR = 3

  class Panoramic extends BaseModule {
    preInit() {
      this.eventId = 'mousemove_' + __.generateID(10)
      this.$bindParent = this.isMobile ? this.$spread : $('body')
      this.$parent = this.$el.parent()
      this.$page = this.$el.closest('.page')
      this.$switcherItem = this.$el.closest('.is__switcherItem')
      this.switchOn = this.$switcherItem.length ? (this.$switcherItem.attr('data-switch-on') || '1') : undefined

      this.initialBackgroundPositionX = this.$el.css('background-position-x')

      this.isParentScrollable = this.$parent.hasClass('spread-holder') ||
        (this.$parent.hasClass('page-in') && this.$page.hasClass('is__sticky')) ||
        this.$el.is('.is__scrollable') // HACK: should probably be default value

      this.isImagePositionAbsolute = this.$el.css('position') === 'absolute'

      this.isAffectingHeight = this.isParentScrollable && !this.isImagePositionAbsolute
      this.isBleed = this.$el.is('.is__bleed')

      this.bindEvents()
    }

    preReset() {
      this.isWideImage = false

      this.currentX = this.defaultCurrentX
      this.lastX = this.currentX
      this.lastTouchX = this.currentX

      this.$el.removeClass(CLASS_WIDE_IMAGE)
      this.$el.css({ width: 'auto', height: 'auto' })
    }

    preCalculate() {
      this.spreadWidth = this.$spread.width()
      this.spreadHeight = this.$spread.height()

      this.parentWidth = this.$parent.width()
      this.parentHeight = this.$parent.height()

      this.parentProportions = this.getProportions(this.parentWidth, this.parentHeight)
      this.elProportions = this.getProportions(this.$el.attr('data-width'), this.$el.attr('data-height'))
    }

    preRender() {
      if (this.isBleed) {
        this.parentHeight = this.$el.height()
        this.parentWidth = this.$el.width()
        this.parentProportions = this.getProportions(this.parentWidth, this.parentHeight)
      }

      if (this.elProportions > this.parentProportions) {
        this.resizePanoramicImage()
      } else {
        this.resizeImage()
      }

      if (this.isImagePositionAbsolute && this.parentHeight < this.$el.height()) {
        this.setImageSize(this.$el.width(), this.parentHeight)
      }

      if (this.isWideImage) this.$el.addClass(CLASS_WIDE_IMAGE)
    }

    get hasFocalPoint() {
      return this.$el.hasClass('has__focalPoint')
    }

    get defaultBackgroundPositionX() {
      if (this.hasFocalPoint) return this.initialBackgroundPositionX
      if (this.$el.is('.is__panoramicLeft')) return 'left'
      if (this.$el.is('.is__panoramicRight')) return 'right'

      return 'center'
    }

    get initialCurrentX() {
      return this.spreadWidth * parseInt(this.initialBackgroundPositionX, 10) / 100
    }

    get defaultCurrentX() {
      if (this.hasFocalPoint) return this.initialCurrentX
      if (this.$el.is('.is__panoramicLeft')) return 0
      if (this.$el.is('.is__panoramicRight')) return this.spreadWidth

      return this.spreadWidth / 2
    }

    get isInsideOfInactiveSwitcherImage() {
      return !!this.switchOn && this.switchOn !== this.spread.anchor?.id
    }

    getProportions(width, height) {
      return (width && height) ? (width / height) : 0
    }

    bindEvents() {
      const { eventId } = this

      this.$spread.on('spreadVisualized', () => {
        if (this.isWideImage) {
          this.$bindParent
            .on(`touchstart.${eventId} touchend.${eventId}`, this.trackTouchStartEnd.bind(this))
            .on(`mousemove.${eventId} touchmove.${eventId}`, this.moveEl.bind(this))
        }
      })

      this.$spread.on('spreadDevisualized', () => {
        this.$bindParent
          .off(`touchstart.${eventId} touchend.${eventId}`)
          .off(`mousemove.${eventId} touchmove.${eventId}`)
      })
    }

    resizePanoramicImage() {
      this.wideImageWidth = this.parentHeight * this.elProportions
      this.ratio = (this.wideImageWidth - this.parentWidth) / this.spreadWidth
      this.currentX = this.defaultCurrentX
      this.lastTouchX = this.currentX
      this.lastX = this.currentX
      this.isWideImage = true
      this.setImageSize(this.parentWidth, this.parentHeight)
    }

    resizeImage() {
      if (this.isParentScrollable) {
        this.growImageInHeight()
      } else {
        this.fitImageInParent()
      }
    }

    growImageInHeight() {
      this.highImageHeight = this.parentWidth / this.elProportions
      this.setImageSize(this.parentWidth, this.highImageHeight)
    }

    fitImageInParent() {
      this.setImageSize(this.parentWidth, this.parentHeight)
    }

    setImageSize(width, height, backgroundPositionX) {
      if (!backgroundPositionX) backgroundPositionX = this.defaultBackgroundPositionX

      if (this.isBleed) return this.$el.css({ 'background-position-x': backgroundPositionX })

      return this.$el.css({
        width: `${width}px`,
        height: `${height}px`,
        'background-position-x': backgroundPositionX,
      })
    }

    trackTouchStartEnd(e) {
      if (this.isMobile && this.isInsideOfInactiveSwitcherImage) return

      if (e.type === 'touchend') {
        if (this.isTouchMoveInProcess) {
          this.lastX = this.currentX
          this.isTouchMoveInProcess = false
        }
      } else {
        this.lastTouchX = ((e.originalEvent || {}).touches || [{}])[0].clientX
      }
    }

    moveEl(e) {
      if (this.isMobile && this.isInsideOfInactiveSwitcherImage) {
        this.lastX = this.currentX
        this.lastTouchX = ((e.originalEvent || {}).touches || [{}])[0].clientX
        return
      }

      if (e.type === 'mousemove' && this.isMobile) return

      this.isTouchMoveInProcess = true
      this.currentX = this.calculateCurrentX(e)
      const offset = this.currentX * this.ratio

      this.$el.css('background-position-x', `-${offset}px`)
    }

    calculateCurrentX(e) {
      let x = e.clientX

      if (e.type === 'touchmove') {
        const { clientX } = ((e.originalEvent || {}).touches || [{}])[0]
        const distance = this.lastTouchX - clientX
        x = this.lastX + distance * MOBILE_SCROLL_FACTOR

        if (x < 0) x = 0
        if (x > this.spreadWidth) x = this.spreadWidth
      }

      return x
    }

    get isMobile() {
      return 'ontouchstart' in window
    }
  }

  $('.image.is__panoramic, .image.is__panoramicLeft, .image.is__panoramicRight, .image.is__panoramicCenter').each(function() {
    new Panoramic($(this))
  })
}
